module.exports = __webpack_public_path__ + "static/media/23.2ab012ec.jpg";